<div *ngIf="preloaderInDom" class="app-preloader" [class.app-preloader--visible]="preloaderVisible">
  <div class="app-preloader__backdrop"></div>
  <div class="app-preloader__content">
    <div class="app-preloader__logo">
      <img src="assets/images/logos/gipant-logo.svg"
           alt="GiPant logo"
           class="app-preloader__logo-image app-preloader__logo-image--gipant"/>
      <img src="assets/images/logos/henterpant-logo.svg"
           alt="Henter Pant logo"
           class="app-preloader__logo-image app-preloader__logo-image--henter"/>
    </div>
    <div class="app-preloader__spinner" role="status" aria-live="polite">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>

<app-header></app-header>
<main>
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>

<ngx-smart-modal #changePasswordModal identifier="changePasswordModal" [dismissable]="false" [customClass]="'change-password-modal'">
  <app-change-password [queryData]="changePasswordModal.getData()"></app-change-password>
</ngx-smart-modal>

<ngx-smart-modal #noTeamsModal identifier="noTeamsModal" [dismissable]="false" [customClass]="'registration-modal no-teams-modal'">
  <app-no-teams-info [city]="noTeamsModal.getData()"></app-no-teams-info>
</ngx-smart-modal>

<ngx-smart-modal #registrationModal identifier="endConsumerRegModal" [customClass]="'registration-modal'" [dismissable]="false">
  <app-sign-up-endconsumer [modalData]="registrationModal.getData()"></app-sign-up-endconsumer>
</ngx-smart-modal>

<ngx-smart-modal #loginModal identifier="loginModal" [customClass]="'login-modal'">
  <app-login-endconsumer></app-login-endconsumer>
</ngx-smart-modal>

<app-cookie-consent></app-cookie-consent>
